<template>
	<div v-if="runtimeConfig.public.ENABLE_COUPON_CODES">
		<div
			v-if="hasAppliedPromocode"
			class="mt-4 flex items-center justify-between rounded-md border-2 border-card-checkout-left-border bg-secondary/5 px-3 py-2 text-sm">
			<div>
				<p class="font-semibold text-primary">{{ appliedPromocode.promocode }}</p>
				<p class="text-ternary">
					{{ $t("discounts") }}:
					{{
						appliedPromocode.type === "percentage"
							? `${appliedPromocode.value}%`
							: `${currency.symbol}${numberHelper.formatPrice(Number(appliedPromocode.value || 0))}`
					}}
				</p>
			</div>

			<button
				type="button"
				class="flex h-8 w-8 items-center justify-center rounded-full text-card-checkout-left-border transition hover:bg-secondary/10 hover:text-card-checkout-left-border"
				:aria-label="$t('removeCoupon', { code: appliedPromocode.promocode })"
				@click="removeCouponCode">
				<IconsFontAwesome icon="fa-solid fa-trash" />
			</button>
		</div>
	</div>
</template>

<script setup>
	import { useNuxtApp } from "#app"
	import numberHelper from "assets/helpers/numberHelper.js"
	import { useCartStore } from "~/stores/CartStore"
	import { useCurrencyStore } from "~/stores/CurrencyStore"
	import { storeToRefs } from "pinia"

	const runtimeConfig = useRuntimeConfig()
	const { $cartService } = useNuxtApp()
	const cartStore = useCartStore()
	const { cartId, appliedPromocode } = storeToRefs(cartStore)
	const currencyStore = useCurrencyStore()
	const { currency } = storeToRefs(currencyStore)

	const removeCouponCode = () => {
		$cartService.$removePromoCode()
	}

	const hasAppliedPromocode = computed(() => {
		return appliedPromocode.value ? !!appliedPromocode.value.promocode : false
	})
</script>

<style scoped></style>
